import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const RefreshFailed: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100" data-testid="refresh-failed-page">
      <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-lg" data-testid="refresh-failed-content">
        <h1 className="text-4xl font-bold text-red-600 mb-4" data-testid="refresh-failed-title">{t('error.oops')}</h1>
        <p className="text-xl text-gray-700 mb-6" data-testid="refresh-failed-message">{t('auth.refreshFailed')}</p>
        <Link
          to="/login"
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          data-testid="refresh-failed-login-link"
        >
          {t('auth.login')}
        </Link>
      </div>
    </div>
  );
};

export default RefreshFailed; 